import { render, staticRenderFns } from "./wxSettingsIndex.vue?vue&type=template&id=000eb4c5&scoped=true"
import script from "./wxSettingsIndex.vue?vue&type=script&lang=js"
export * from "./wxSettingsIndex.vue?vue&type=script&lang=js"
import style0 from "./wxSettingsIndex.vue?vue&type=style&index=0&id=000eb4c5&prod&lang=css"
import style1 from "./wxSettingsIndex.vue?vue&type=style&index=1&id=000eb4c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000eb4c5",
  null
  
)

export default component.exports